<div class="container-fluid">
    <div class="modal-header">
        <h4 *ngIf="modalMode === 'Add'">Add Multiple Attachment</h4>
        <a class="close-icon" href="javascript:void()" ngbAutofocus (click)="modalService.close(false)">
            <i class="flaticon2-cross"></i>
        </a>
    </div>
    <div class="modal-body output-lable">
        <div class="row hero-image-card">
            <div class="col-md-12">
                <div class="card card-custom gutter-b card-stretch">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-3" style="padding: 15px">
                                <mat-label class="font-style">Select File(s) to Upload</mat-label>
                            </div>
                            <div class="col-md-9">
                                <ng-container>
                                    <div class="upload_multi_file">
                                        <div class="image-upload">
                                            <button class="upload-btn">
                                                <input
                                                    class="upload-input"
                                                    type="file"
                                                    (change)="fileChangeEvent($event)"
                                                    multiple
                                                    accept=".pdf, image/*, .xls, .xlsx"
                                                /><i class="pi pi-upload"></i>
                                            </button>
                                            <div class="image-details">
                                                <div class="file-name">Add File</div>
                                                <div class="img-info">PDF, IMAGES,xls,xlsx</div>
                                            </div>
                                        </div>
                                        <ul *ngIf="uploadedFile.length && documentUploadForm" [formGroup]="documentUploadForm">
                                            <li *ngFor="let file of uploadedFile; let i = index">
                                                <div class="fileData">
                                                    <p>{{ file.name }}</p>
                                                    <p class="file-size">{{ (file.size / 1024).toFixed(2) }} KB</p>
                                                </div>
                                                <input class="inputWrap" [formControlName]="file?.name" type="text" placeholder="Document Title" />
                                                <ng-container *ngIf="documentUploadForm.get(file?.name)?.invalid && documentUploadForm.get(file?.name)?.dirty">
                                                    <p class="error-message" *ngIf="documentUploadForm.get(file?.name)?.errors?.maxlength">
                                                        Document Name length should be maximum 255 character.
                                                    </p>
                                                    <p class="error-message" *ngIf="documentUploadForm.get(file?.name)?.errors?.required">
                                                        Document Name should be required.
                                                    </p>
                                                </ng-container>
                                                <div class="closeBtn"><i class="flaticon2-cross" (click)="removeUploadedFile(file)"></i></div>
                                            </li>
                                        </ul>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn secondary-ebtn" (click)="modalService.close(false)">Cancel</button>
        <button type="button" class="btn primary-ebtn" (click)="btnAddClicked()" [disabled]="documentUploadForm?.invalid">
            {{ modalMode === 'Add' ? 'Add Document' : 'Save' }}
        </button>
    </div>
</div>
